const StoreyMap = {
    Single: 1,
    Double: 2,
};

const BlockWidthMap = {
    'Less than 12.5M': {
        min: 0,
        max: 12.49
    },
    '12.5M to 15M': {
        min: 12.5,
        max: 15
    },
    'More than 15M': {
        min: 15.01,
        max: 9999
    },
    '12.5M': {
        min: 12.5,
        max: 12.5
    },
    '14M': {
        min: 14,
        max: 14
    },
    '16M+': {
        min: 16,
        max: 9999
    },
};

window.addEventListener('load', () => {
    const limit = 12;
    var offset = 0;

    const filterContainers = document.querySelectorAll('.filters-container');

    for (const filterContainer of filterContainers) {
        const filterParentSection = filterContainer.closest('.card-filter-panel');
        const filterCardParentSection = filterParentSection?.nextElementSibling;
        const allFilters = [...filterContainer.querySelectorAll('select,input')];
        const allDesignCards = filterCardParentSection ? [...filterCardParentSection.querySelectorAll('.home-design-card, .house-land-package-card')] : [];
        const allInterstitials = filterCardParentSection ? [...filterCardParentSection.querySelectorAll('.interstitial-card')] : [];

        const clearButton = filterContainer.querySelector('button.clear-button');
        const cardContainer = allDesignCards?.[0]?.parentElement;
        const defaultFilterValues = {};

        const loadMore = (event) => {
            offset += limit;
            const nonFilteredDesignCards = filterCardParentSection?.querySelectorAll('.filterable-card[data-filtered="false"], .interstitial-card');
            const firstNonInterstitialCard = filterCardParentSection?.querySelector('.filterable-card[data-filtered="false"]');
            const startAtIndex = nonFilteredDesignCards ? [...nonFilteredDesignCards].indexOf(firstNonInterstitialCard) : -1;
            if (nonFilteredDesignCards && (startAtIndex !== -1)) {
                nonFilteredDesignCards.forEach((cardElement, index) => {
                    if (index >= startAtIndex && index < (offset + startAtIndex)) {
                        cardElement.setAttribute('data-loaded', 'true');
                    }
                });
            }

            const loadMoreButton = event ? event.currentTarget : filterCardParentSection?.querySelector('button.load-more');
            const shownNonInstertitialCards = filterCardParentSection ? filterCardParentSection.querySelectorAll('.filterable-card[data-filtered="false"]').length : 0;
            const loadedCards = filterCardParentSection ? filterCardParentSection.querySelectorAll('.filterable-card[data-loaded="true"]').length : 0;

            if (loadMoreButton) {
                if (loadedCards < shownNonInstertitialCards) {
                    loadMoreButton.classList.remove('hidden');
                }
                else {
                    loadMoreButton.classList.add('hidden');
                }
            }
        }

        const resetLoadedItems = () => {
            offset = 0;
            const loadedCards = filterCardParentSection?.querySelectorAll('[data-loaded]');
            if (loadedCards) {
                loadedCards.forEach((card) => {
                    card.setAttribute('data-loaded', 'false');
                });
            }
        }

        const selectVariant = (designCard, dataFieldName, value) => {
            const variant = designCard.querySelector(`[data-variant][${dataFieldName}="${value}"]`);
            if (variant) {
                const variantNum = variant.getAttribute('data-variant');
                const variantButton = designCard.querySelector(`button[data-toggle-variant="${variantNum}"]`);
                variantButton?.click();
            }
        };

        const onFiltersChanged = (event) => {
            resetLoadedItems();
            if (event?.target?.getAttribute('data-for') === 'Sort') {
                // there are 2 sort filter elements, 1 for mobile and 1 for desktop
                // so lets sync the value changes between them

                const otherSort = [...filterContainer.querySelectorAll('select[data-for="Sort"]')].filter((sortFilter) => sortFilter !== event.target).pop();
                otherSort.value = event.target.value;
            }

            const filterValues = [...allFilters].reduce((carry, filterElement) => {
                const dataFor = filterElement.getAttribute('data-for');
                const output = {
                    ...carry
                };

                if (dataFor) {
                    if (filterElement instanceof HTMLSelectElement) {
                        output[dataFor] = filterElement.value;
                    }
                    else if (filterElement instanceof HTMLInputElement) {
                        switch ( filterElement.getAttribute('type') ) {
                            case 'checkbox':
                                output[dataFor] = output?.[dataFor] ?? [];
                                if (filterElement.checked) {
                                    output[dataFor].push(filterElement.value);
                                }
                                break;

                            default:
                                output[dataFor] = filterElement.value;
                        }
                    }
                }

                return output;
            }, {});

            allDesignCards.forEach((designCard) => {
                let cardHidden = false;

                for ( let key in filterValues ) {
                    const dataAttrib = `data-${key.toLowerCase().replace(' ', '-')}`;

                    if (designCard.hasAttribute(dataAttrib)) {
                        let cardValue = designCard.getAttribute(dataAttrib);
                        let filterValue = filterValues[key];

                        switch (key) {
                            // Skip at this stage
                            case 'Sort':
                                break;

                            // Title search to also search suburb
                            case 'Title':
                                const suburbVal = designCard.getAttribute('data-suburb');
                                const suburbNotFound = suburbVal ? suburbVal.toLowerCase().indexOf(filterValue.toLowerCase()) === -1 : true;

                                if (cardValue.toLowerCase().indexOf(filterValue.toLowerCase()) === -1 && suburbNotFound) {
                                    cardHidden = true;
                                }
                                break;

                            case 'Block Width': {
                                filterValue = BlockWidthMap?.[filterValue] ?? {min: -1, max: 200};
                                cardValue = cardValue.split(',');
                                let variantSelected = false;
                                let widthIsWithinLimit = false;
                                for (let width of cardValue) {
                                    if (width >= filterValue.min && width <= filterValue.max) {
                                        widthIsWithinLimit = true;

                                        if (cardValue.length > 0 && !variantSelected) {
                                            selectVariant(designCard, 'data-block-width', width);
                                            variantSelected = true;
                                        }
                                    }
                                }
                                cardHidden = cardHidden || !widthIsWithinLimit;
                                }
                                break;

                            case 'Features':
                                cardValue = cardValue.split(',');

                                for ( let feature of filterValue ) {
                                    if (cardValue.indexOf(feature) === -1) {
                                        cardHidden = true;
                                        break;
                                    }
                                }
                                break;

                            case 'Beds':
                            case 'Baths':
                            {
                                let cardIncluded = false;
                                if (filterValue == 'Any') {
                                    cardIncluded = true;
                                } else {
                                    cardValue = cardValue.split(',');
                                    let variantSelected = false;
                                    for ( let value of cardValue ) {
                                        if (value.toString() == filterValue.toString()) {
                                            cardIncluded = true;

                                            if (cardValue.length > 0 && !variantSelected) {
                                                selectVariant(designCard, dataAttrib, value);
                                                variantSelected = true;
                                            }
                                        }
                                    }
                                }
                                cardHidden = cardHidden || !cardIncluded;
                            }
                            break;

                            case 'Storeys':
                                // map storeys to an integer
                                filterValue = StoreyMap?.[filterValue] ?? 'Any';
                            // fall-through
                            default:
                                if (filterValue !== 'Any' && filterValue.toString() !== cardValue.toString()) {
                                    cardHidden = true;
                                }
                                break;
                        }
                    }
                }

                designCard.setAttribute('data-filtered', cardHidden.toString());
            });

            allDesignCards.sort((cardElementA, cardElementB) => {
                const titleA = cardElementA.getAttribute('data-title');
                const titleB = cardElementB.getAttribute('data-title');

                switch ( filterValues['Sort'] ) {
                    case 'A - Z':
                        return titleA.localeCompare(titleB);

                    case 'Z - A':
                        return titleB.localeCompare(titleA);

                    case 'Most Popular':
                        const originalSortA = cardElementA.getAttribute('data-original-sort');
                        const originalSortB = cardElementB.getAttribute('data-original-sort');
                        return parseInt(originalSortA) - parseInt(originalSortB);

                    case 'Recently Added':
                        const timestampA = cardElementA.getAttribute('data-posted');
                        const timestampB = cardElementB.getAttribute('data-posted');

                        if (timestampA === timestampB) {
                            const idA = cardElementA.getAttribute('data-id');
                            const idB = cardElementB.getAttribute('data-id');
                            return idB - idA;
                        }
                        else {
                            return timestampB - timestampA;
                        }
                }

                return 0;
            });

            allInterstitials.forEach((interstitial) => interstitial.setAttribute('data-loaded', 'false'));

            let nextInterstitialIndex = 5;
            let interstitialIndex = 0;
            let cardIndex = 0;

            allDesignCards.forEach((cardElement) => {
                if (nextInterstitialIndex === cardIndex) {
                    const interstitial = allInterstitials?.[interstitialIndex];

                    if (interstitial) {
                        cardContainer.appendChild(interstitial);
                        nextInterstitialIndex += Math.round(3 + (Math.random() * 3));
                        interstitialIndex++;
                    }
                }

                cardContainer.appendChild(cardElement);

                if (cardElement.getAttribute('data-filtered') !== 'true') {
                    cardIndex++;
                }
            });

            allFilters.filter((filterElement) => filterElement instanceof HTMLSelectElement && filterElement.classList.contains('feature-select')).forEach((filterElement) => {
                filterElement.firstElementChild.innerText = filterValues.Features.length ? `${filterValues.Features.length} Selected` : 'Any'
            });

            const cardTitleDiv = filterParentSection?.querySelector('.card-filter-title');
            const shownCards = filterCardParentSection ? filterCardParentSection.querySelectorAll('.filterable-card[data-filtered="false"]').length : 0;
            const entryCount = cardTitleDiv?.querySelector('.entry-count');
            const entryType = cardTitleDiv?.querySelector('.entry-type');
            if (entryCount) {
                entryCount.innerHTML = shownCards.toString();
            }
            if (entryType) {
                entryType.innerHTML = shownCards === 1 ? cardTitleDiv.getAttribute('data-singular-title') : cardTitleDiv.getAttribute('data-plural-title');
            }

            loadMore();
        };

        clearButton?.addEventListener('click', () => {
            allFilters.forEach((filterElement) => {
                const key = filterElement.getAttribute('data-for');
                if (defaultFilterValues.hasOwnProperty(key)) {
                    filterElement.value = defaultFilterValues[key];
                }

                if (filterElement.type === 'checkbox') {
                    filterElement.checked = false;
                }
            });

            onFiltersChanged();
        });

        // If we click outside of our multiselect, then close it :)
        document.addEventListener('click', (event) => {
            const source = event.target;
            const isInsideMultiselect = !!source.closest('.multi-select-content');

            if (!isInsideMultiselect) {
                filterContainer.querySelectorAll('.multi-select-content[data-open="true"]').forEach((element) => {
                    element.classList.remove('opacity-100');
                    element.classList.remove('pointer-events-auto');
                    element.setAttribute('data-open','false');
                });
            }
        });

        allFilters.forEach((filterElement) => {
            filterElement.addEventListener('change', onFiltersChanged);

            if (filterElement instanceof HTMLInputElement && filterElement.type === 'text') {
                filterElement.addEventListener('input', _debounce(onFiltersChanged, 500));
            }

            if (filterElement.classList.contains('multi-select-filter')) {
                const clickElement = filterElement.parentElement.querySelector('.multi-select-click');
                const contentElement = filterElement.parentElement.querySelector('.multi-select-content');

                clickElement.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    const isCurrentlyOpen = contentElement.getAttribute('data-open') === 'true';

                    contentElement.classList.toggle('opacity-100', !isCurrentlyOpen);
                    contentElement.classList.toggle('pointer-events-auto', !isCurrentlyOpen);
                    contentElement.setAttribute('data-open',(!isCurrentlyOpen).toString());
                });
            }

            if (filterElement.type !== 'checkbox') {
                const dataFor = filterElement.getAttribute('data-for');

                if (dataFor) {
                    defaultFilterValues[filterElement.getAttribute('data-for')] = filterElement.value;
                }
            }
        });

        onFiltersChanged();

        const loadMoreButton = filterCardParentSection?.querySelector('button.load-more');
        loadMoreButton?.addEventListener('click', loadMore);
    }
});